import type { ItemStoreState } from "@editor/items/ItemStore";
import type { SimulationItem } from "@editor/items/simulation/SimulationItem";

export default {
  applyToVersions: "<2.6.2",
  type: "before",
  name: "remove game type",
  migrate(data: { simulations?: ItemStoreState<SimulationItem> }) {
    if (!data.simulations) return data;

    for (const simId in data.simulations.items) {
      const simulation: SimulationItem = data.simulations.items[simId];
      if (simulation.type != "simulation") simulation.type = "simulation";
      if (!simulation.uid.startsWith("simulation")) {
        simulation.uid = simulation.type + "_" + simulation.id;
      }
    }

    return data;
  }
};
